/** @desc eventId和唯一key的映射表 */

export const eventMap = {
  sailing_c_x_sf_item_sw: 'item_id',
  sailing_c_x_sf_tab_sw: 'tab_id',
  sailing_c_x_sf_brand_shop_sw: 'shop_id',
}
